import type { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { Children } from 'react';
import { isFragment } from 'react-is';
import { ActionModeProvider } from 'src/components/action-mode';
import type { ActionMode } from 'src/components/action-mode';
import { Stack } from 'src/components/layout/stack';
import { useBreakpoints } from 'src/hooks/use-breakpoints';
import { useIsNewDesignActive } from 'src/pages/new-design/is-new-design';
import { cn } from 'src/utils/cn';

const actionMode: ActionMode = { mode: 'tab' };

type TabsProps = {
  actions?: ReactNode;
} & ComponentPropsWithoutRef<'div'>;

export const Tabs: FC<TabsProps> = ({ actions, ...props }) => {
  const isNewDesignActive = useIsNewDesignActive();
  const { minTablet } = useBreakpoints();
  return (
    <Stack
      flow={minTablet ? 'column' : 'row'}
      gap={1}
      justifyContent="space-between"
      {...props}
      className={cn(
        'not-legacy:md:border-b-1 not-legacy:md:border-b-border-surface-minimal',
        props.className
      )}
    >
      <Stack
        flow={minTablet ? 'column' : 'row'}
        gap={isNewDesignActive ? 0 : 2.5}
        inline
      >
        <ActionModeProvider value={actionMode}>
          {Children.map(props.children, function recursive(child): ReactNode {
            if (isFragment(child)) {
              return Children.map(child.props.children, recursive);
            } else if (child) {
              return child;
            } else {
              return null;
            }
          })}
        </ActionModeProvider>
      </Stack>

      {actions}
    </Stack>
  );
};
